export default __webpack_public_path__ + "static/media/hover3.daea6a01.png";